import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';


const baseQueryWithReAuth = createBaseQuery('media');

export const resourcesApiSlice = createApi({
  reducerPath: 'resourcesApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['Resources'],
  endpoints: (builder) => ({
    getResources: builder.query({
      query: () => '/resources',
      providesTags: ['Resources']
    }),
    createResource: builder.mutation({
      query: (newResource) => ({
        url: '/resources',
        method: 'POST',
        body: newResource
      }),
      invalidatesTags: ['Resources']
    }),
    updateResource: builder.mutation({
      query: ({ resourceId, updatedResource }) => ({
        url: `/resources/${resourceId}`,
        method: 'PUT',
        body: updatedResource
      }),
      invalidatesTags: ['Resources']
    }),
    deleteResource: builder.mutation({
      query: (resourceId) => ({
        url: `/resources/${resourceId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Resources']
    })
  })
});

export const {
  useGetResourcesQuery,
  useCreateResourceMutation,
  useUpdateResourceMutation,
  useDeleteResourceMutation
} = resourcesApiSlice;
